import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import GlassMenu from "../GlassMenu";
import NewHero from "../newhero";
import Waitlist from "../waitlist";
import ModifiedMission from "../abridgedmission";
import FadeTesting from "../fadetesting";
import Announcement from "../announcements";
import HowItWorksMobile from "../HowItWorksMobile";
import HowItWorksV5 from "../HowItWorksV5";
import Footer from "../footer";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Homepage() {
  console.log("HomePage mounted");


  const heroRef = useRef(null);
  const latchRef = useRef(null);

  const [latched, setLatched] = useState(false);

  useEffect(() => {
    const heroEl = heroRef.current;
    const latchEl = latchRef.current;
    if (!heroEl || !latchEl) return;

    // 👇 tweak: how far after the hero (in viewport heights) the button "lives" in the flow
    // 0.25 = 25vh after hero, 1.0 = one viewport after hero, etc.
    const appearAfterVH = 1.15;

    let raf = 0;
    let latchY = 0;

    const computeLatchY = () => {
      const heroRect = heroEl.getBoundingClientRect();
      const heroBottomDocY = window.scrollY + heroRect.bottom;

      // Where the placeholder should be in the document
      const placeholderDocY = heroBottomDocY + window.innerHeight * appearAfterVH;

      // We "latch" when the placeholder reaches bottom:24px
      // placeholderTopInViewport = placeholderDocY - scrollY
      // latch when placeholderTopInViewport <= (vh - 24 - buttonHeight)
      // We'll read actual placeholder height to avoid magic numbers.
      const ph = latchEl.getBoundingClientRect().height || 44;

      latchY = placeholderDocY - (window.innerHeight - 24 - ph);
    };

    const update = () => {
      raf = 0;
      setLatched(window.scrollY >= latchY);
    };

    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    computeLatchY();
    update();

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", () => {
      computeLatchY();
      schedule();
    });

    // If hero height changes after images load
    window.addEventListener("load", () => {
      computeLatchY();
      schedule();
    });

    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("load", computeLatchY);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const isMobile = useIsMobile();

  if (isMobile){
    return (
      <div className="Homepage">
        <Helmet>
          <title>Commonwealth | The world's first lending market.</title>
        </Helmet>

        <div ref={heroRef}>
          <NewHero />
        </div>

        <Announcement />

        {/* latch probe (in-flow) */}
        <div
          ref={latchRef}
          style={{
            height: "1px",
            width: "1px",
            opacity: 0,
            pointerEvents: "none",
          }}
        />

        <ModifiedMission />
        <Waitlist />
        <FadeTesting />
        <HowItWorksMobile />
        <Footer />

        {/* =========================
            FIXED (LATCHED) VERSION
            This fades in from bottom when latched.
           ========================= */}
        <div className="glassMenuDock">
          <GlassMenu visible={latched} />
        </div>
      </div>
    )
  } else {
  return (
    <div className="Homepage">
      <Helmet>
        <title>Commonwealth | The world's first lending market.</title>
      </Helmet>

      <div ref={heroRef}>
        <NewHero />
      </div>

      <Announcement />

      {/* latch probe (in-flow) */}
      <div
        ref={latchRef}
        style={{
          height: "1px",
          width: "1px",
          opacity: 0,
          pointerEvents: "none",
        }}
      />

      <ModifiedMission />
      <Waitlist />
      <FadeTesting />
      <HowItWorksV5 />
      <Footer />

      {/* =========================
          FIXED (LATCHED) VERSION
          This fades in from bottom when latched.
         ========================= */}
      <div className="glassMenuDock">
        <GlassMenu visible={latched} />
      </div>
    </div>
  );
}
}
